package components.loadingSpinner

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 13.10.22
 * Author : marcusspors
 */

import core.AppContext
import react.FC
import react.Props
import react.useContext
import react.useEffectOnce


external interface LoadingSpinnerProps : Props {
}

val LoadingSpinner = FC<LoadingSpinnerProps> { props ->

    val mContext by useContext(AppContext)

    useEffectOnce {
        mContext.mSetIsLoading(true)
        cleanup {
            mContext.mSetIsLoading(false)
        }
    }

}
